import React, { Fragment } from "react";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
import { FormattedMessage, FormattedNumber } from "react-intl";
import styles from "./AccountDetails.module.less";
import DateOfService from "assets/scripts/components/presentational/DateOfService/DateOfService";
const AccountDetails = ({ account }) => {
    let title = <AccountNumber value={account.acctNum}/>;
    if (process.env.CLIENT == null || account.creditor != null) {
        title = (<Fragment>
				{account.creditor} ({title})
			</Fragment>);
    }
    return (<Fragment>
			<div className={styles.title}>
				{title}
			</div>
			<div className={styles.other}>
				<FormattedMessage id="forms.payNow.amount.amountDue" defaultMessage="Amount Due"/>
				:{" "}
				<strong>
					<FormattedNumber value={account.amountDue} style="currency" currency="USD"/>
				</strong>
			</div>
			{(account.admitDate != null || account.dischargeDate != null) && (<div className={styles.other}>
					<FormattedMessage id="forms.payNow.amount.dateOfService" defaultMessage="Date of Service"/>
					:{" "}
					<DateOfService account={account}/>
				</div>)}
		</Fragment>);
};
export default AccountDetails;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/PaymentInfoFields/AccountDetails/AccountDetails.tsx